import { render, staticRenderFns } from "./UserFilterWrapper.vue?vue&type=template&id=39c5ad16&scoped=true&"
import script from "./UserFilterWrapper.vue?vue&type=script&lang=ts&"
export * from "./UserFilterWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./UserFilterWrapper.vue?vue&type=style&index=0&id=39c5ad16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c5ad16",
  null
  
)

export default component.exports